/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { Checkbox } from '@powdr/components';
import { ButtonText } from '@powdr/constants';

export const GroupsBookingForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const [eldoraContact, setEldoraContact] = useState();
  const captchaRef = useRef();

  const selectRadio = (id) => {
    const radio = document.getElementById(id);
    if (radio) radio.checked = true;
  };

  const selectCheckbox = (id) => {
    const checkbox = document.getElementById(id);
    if (checkbox) checkbox.checked = true;
  };

  return (
    <form
      id="groups-booking"
      onSubmit={(e) => processForm(e, '10968ca02964', null, captchaRef)}
    >
      <h2>Eldora Group Booking Request</h2>

      <p>
        Completion of this form does not guarantee Eldora will be able to
        accommodate your group.
      </p>

      <p>* = Required Field</p>

      <hr />

      <h3 className="form-section-head">
        Group Contact&apos;s Name *
      </h3>

      <input
        className="form-control"
        id="groupContactName"
        name="Group Contact Name"
        type="text"
        required
      />

      <h3 className="form-section-head">
        Group Contact&apos;s Email address *
      </h3>

      <input
        className="form-control"
        id="email"
        name="Group Contact Email"
        type="email"
        required
      />

      <h3 className="form-section-head">
        Group Contact&apos;s Phone Number *
      </h3>

      <input
        className="form-control"
        id="phoneNumber"
        name="Group Contact Phone Number"
        type="tel"
        required
      />

      <h3 className="form-section-head">
        Company/Group Name *
      </h3>

      <input
        className="form-control"
        id="groupName"
        name="Group Name"
        type="text"
        required
      />

      <h3 className="form-section-head">
        What type of organization are you a part of? *
      </h3>

      <ul className="l-group">
        <li className="l-item">
          <input
            className="radio"
            id="organization-school"
            type="radio"
            name="Organization Type"
            value="School Group"
            required
          />

          <label htmlFor="organization-school">
            School Group
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="organization-corporate"
            type="radio"
            name="Organization Type"
            value="Corporate Group"
          />

          <label htmlFor="organization-corporate">
            Corporate Group
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="organization-nonprofit"
            type="radio"
            name="Organization Type"
            value="Non-profit Group"
          />

          <label htmlFor="organization-nonprofit">
            Non-profit Group
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="organization-social"
            type="radio"
            name="Organization Type"
            value="Social Group"
          />

          <label htmlFor="organization-social">
            Social Group
          </label>
        </li>

        <li className="l-item">
          <label
            htmlFor="organization-other"
            className="other-option"
          >
            <input
              className="radio"
              id="organization-other"
              type="radio"
              name="Organization Type"
              value="Other"
            />

            <input
              className="form-control"
              id="organization-other-text"
              type="text"
              name="organizationOther"
              placeholder="Other"
              maxLength={1000}
              onFocus={() => selectRadio('organization-other')}
            />
          </label>
        </li>
      </ul>

      <h3 className="form-section-head">
        What type of event or product is your group interested in? *
      </h3>

      <ul className="l-group">
        <li className="l-item">
          <input
            className="radio"
            id="event-school-trip"
            type="radio"
            name="Event Type"
            value="School Trip/ Field Trip"
            required
          />

          <label htmlFor="event-school-trip">
            School Trip/ Field Trip
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="event-group-outing"
            type="radio"
            name="Event Type"
            value="Group Outing"
          />

          <label htmlFor="event-group-outing">
            Group Outing
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="event-executive-retreat"
            type="radio"
            name="Event Type"
            value="Executive Retreat"
          />

          <label htmlFor="event-executive-retreat">
            Executive Retreat
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="event-company-meeting"
            type="radio"
            name="Event Type"
            value="Group/Company Meeting"
          />

          <label htmlFor="event-company-meeting">
            Group/Company Meeting
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="event-social-event"
            type="radio"
            name="Event Type"
            value="Social Event (Wedding, Birthday, or Celebration of Life, etc.)"
          />

          <label htmlFor="event-social-event">
            Social Event (Wedding, Birthday, or Celebration of Life, etc.)
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="event-no-event"
            type="radio"
            name="Event Type"
            value="No Event: Just Tickets/Passes/Rentals for Employees or Group Members"
          />

          <label htmlFor="event-no-event">
            No Event: Just Tickets/Passes/Rentals for Employees or Group Members
          </label>
        </li>

        <li className="l-item">
          <label
            htmlFor="event-other"
            className="other-option"
          >
            <input
              className="radio"
              id="event-other"
              type="radio"
              name="Event Type"
              value="Other"
            />

            <input
              className="form-control"
              id="event-other-text"
              type="text"
              name="eventTypeOther"
              placeholder="Other"
              maxLength={1000}
              onFocus={() => selectRadio('event-other')}
            />
          </label>
        </li>
      </ul>

      <h3 className="form-section-head">
        What date or dates would your group like to come? *
      </h3>

      <input
        className="form-control"
        id="group-dates"
        name="Dates"
        type="text"
        required
      />

      <h3 className="form-section-head">
        How many people are in your group? *
      </h3>

      <input
        className="form-control"
        id="group-size"
        name="Group Size"
        type="number"
        required
      />

      <h3 className="form-section-header">
        What items will your group need? *
      </h3>

      <div className="checkbox-grid">
        <Checkbox
          id="group-needs-lift-tickets"
          name="Group Needs[]"
          value="Alpine Lift Tickets"
          label="Alpine Lift Tickets"
          ariaLabel="Alpine Lift Tickets"
        />

        <Checkbox
          id="group-needs-rentals"
          name="Group Needs[]"
          value="Alpine Rentals"
          label="Alpine Rentals"
          ariaLabel="Alpine Rentals"
        />

        <Checkbox
          id="group-needs-lessons"
          name="Group Needs[]"
          value="Alpine Ski or Snowboard Lessons"
          label="Alpine Ski or Snowboard Lessons"
          ariaLabel="Alpine Ski or Snowboard Lessons"
        />

        <Checkbox
          id="group-needs-private"
          name="Group Needs[]"
          value="Private Space"
          label="Private Space"
          ariaLabel="Private Space"
        />

        <Checkbox
          id="group-needs-semi-public"
          name="Group Needs[]"
          value="Semi-Public Space"
          label="Semi-Public Space"
          ariaLabel="Semi-Public Space"
        />

        <Checkbox
          id="group-needs-nordic"
          name="Group Needs[]"
          value="Nordic Ski Lift Tickets or Rentals"
          label="Nordic Ski Lift Tickets or Rentals"
          ariaLabel="Nordic Ski Lift Tickets or Rentals"
        />

        <Checkbox
          id="group-needs-other"
          name="Group Needs[]"
          value="Other"
          label=""
          ariaLabel="Other"
        >
          <input
            className="form-control"
            id="group-needs-other-text"
            type="text"
            name="groupNeedsOther"
            placeholder="Other"
            maxLength={1000}
            onFocus={() => selectCheckbox('group-needs-other')}
          />
        </Checkbox>
      </div>

      <h3 className="form-section-header">
        What additional information would you like Eldora to know about your group?
      </h3>

      <textarea
        id="additional-comments"
        rows="9"
        cols="33"
        name="Additional Comments"
      />

      <h3 className="form-section-head">
        Have you spoken with an Eldora employee about your group request? *
      </h3>

      <ul className="l-group">
        <li className="l-item">
          <input
            className="radio"
            id="eldora-contact-yes"
            type="radio"
            name="eldoraContact"
            value="Yes"
            onChange={(e) => setEldoraContact(e.target.value)}
            required
          />

          <label htmlFor="eldora-contact-yes">
            Yes
          </label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="eldora-contact-no"
            type="radio"
            name="eldoraContact"
            value="No"
            onChange={(e) => setEldoraContact(e.target.value)}
          />

          <label htmlFor="eldora-contact-no">
            No
          </label>
        </li>
      </ul>

      {eldoraContact === 'Yes' && (
        <>
          <h3 className="form-section-head">
            Who have you spoken with *
          </h3>

          <input
            className="form-control"
            id="eldora-contact-person"
            name="Eldora Contact Name"
            type="text"
            placeholder="Enter your answer"
            maxLength={4000}
            required
          />
        </>
      )}

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button
        type="submit"
        value="Submit"
        disabled={!isUserVerified}
      >
        {buttonText || ButtonText.SUBMIT}
      </button>
    </form>
  );
};

GroupsBookingForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
